"use strict";

var keyMirror = require("react/lib/keyMirror");

var NativeDragItemTypes = {
  FILE: "__NATIVE_FILE__"
};

module.exports = NativeDragItemTypes;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/react-dnd/dist-modules/constants/NativeDragItemTypes.js
 ** module id = 502
 ** module chunks = 1
 **/